class RDStationSuccessRedirect {
    constructor() {
        this.successUrl = document.querySelector('meta[name="rd-station:success-url"]')?.content;

        if (!this.successUrl) return;

        document.addEventListener('submit', event => this.setRedirect(event.target), true);
    }

    setRedirect(form) {
        if (
            !(form instanceof HTMLFormElement) ||
            !form.matches('form[id^="conversion-form-"][action*="rdstation.com"]')
        ) {
            return;
        }

        let redirectField = form.querySelector('input[name="redirect_to"]');

        if (!redirectField) {
            redirectField = document.createElement('input');
            redirectField.type = 'hidden';
            redirectField.name = 'redirect_to';
            form.appendChild(redirectField);
        }

        redirectField.value = this.successUrl;
    }
}

new RDStationSuccessRedirect();
